import { useState } from "react";
import "./EgfrInfo.css";

function EgfrInfo() {
  const [open, setOpen] = useState(false);

  return (
    <div className="egfr-info">
      {!open && (
        <button
          type="button"
          className="egfr-toggle"
          onClick={() => setOpen(true)}
          aria-expanded={open}
          aria-label="What is EGFR?"
        >
          i
        </button>
      )}

      {open && (
        <aside className="egfr-popout" role="note" aria-live="polite">
          <button
            type="button"
            className="egfr-close"
            onClick={() => setOpen(false)}
            aria-label="Close EGFR info"
          >
            ×
          </button>
          <h3>What is in the background? <b>EGFR</b></h3>
          <p>
            The 3D structure shown in the background represents EGFR (Epidermal
            Growth Factor Receptor), a receptor tyrosine kinase (RTK) embedded
            in the cell membrane. Upon ligand binding, EGFR undergoes
            dimerization and autophosphorylation, initiating intracellular
            signaling cascades that regulate cell proliferation, survival,
            differentiation, and migration. These tightly controlled pathways
            are essential for normal tissue development and homeostasis.
          </p>
          <p>
            Dysregulation of EGFR is implicated in numerous cancers, including
            lung, breast, and glioblastoma. Overexpression, gene amplification,
            and activating mutations can lead to constitutive signaling
            independent of ligand binding, driving persistent and uncontrolled
            cellular growth. Because of its central role in oncogenic signaling,
            EGFR has become a critical therapeutic target, with targeted
            inhibitors significantly improving outcomes in select patient
            populations.
          </p>
          <p>
            I chose to feature this 3D model of EGFR for a couple of reasons.
            First, it represents a protein I find deeply compelling because of
            its central role in both normal cellular signaling and cancer
            development. It highlights how a single molecular system can
            profoundly influence human health. Second, EGFR symbolizes the
            intersection of biology and computation that defines my interests.
            Understanding and visualizing complex biological systems requires
            both scientific insight and technical precision. By combining my
            background in biology with my software engineering expertise, I aim
            to build tools that clarify complexity and contribute to meaningful
            progress in research and healthcare. I want my code to do good in
            the world, and I believe my dual training uniquely positions me to
            help make that impact.
          </p>
          <p>(Also it looks really cool)</p>
        </aside>
      )}
    </div>
  );
}

export default EgfrInfo;
